import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import LoginPage from '../views/LoginPage.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import PrestadoresPage from '../views/PrestadoresPage.vue';
import EquipamentosPage from '../views/EquipamentosPage.vue';
import DadosEmpresaPage from '../views/DadosEmpresaPage.vue';
import ServicosPage from '../views/ServicosPage.vue';
import DashboardPage from '../views/DashboardPage.vue';
import { isAuthenticated } from '@/stores/auth';

const routes = [
  { path: '/', component: LoginPage },
  {
    path: '/home',
    component: HomePage,
    meta: { requiresAuth: true } // Protegido por autenticação
  },
  { path: '/esqueci-senha', component: ForgotPassword },
  {
    path: '/prestadores',
    component: PrestadoresPage,
    meta: { requiresAuth: true } // Protegido por autenticação
  },
  {
    path: '/equipamentos',
    component: EquipamentosPage,
    meta: { requiresAuth: true } // Protegido por autenticação
  },
  {
    path: '/empresa',
    component: DadosEmpresaPage,
    meta: { requiresAuth: true } // Protegido por autenticação
  },
  {
    path: '/servicos',
    name: 'Servicos',
    component: ServicosPage,
    meta: { requiresAuth: true } // Protegido por autenticação
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true } // Protegido por autenticaçãoø
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Adiciona guarda de rota para verificar autenticação
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    // Se não estiver autenticado, redireciona para a página de login4

    next('/');
  } else {

    // Se estiver autenticado ou a rota não requer autenticação, prossegue
    next();
  }

});

export default router;
